import { readonly as u, ref as o, onBeforeMount as w, onBeforeUnmount as m } from "vue";
import { isBrowser as k, hasInstance as p } from "./ghl-ui.es708.js";
import { on as c, off as f } from "./ghl-ui.es710.js";
const T = o(void 0);
let e = 0;
function a() {
  T.value = Date.now();
}
let d = !0;
function h(s) {
  if (!k)
    return u(o(!1));
  const n = o(!1);
  let i = null;
  function t() {
    i !== null && window.clearTimeout(i);
  }
  function l() {
    t(), n.value = !0, i = window.setTimeout(() => {
      n.value = !1;
    }, s);
  }
  e === 0 && c("click", window, a, !0);
  const r = () => {
    e += 1, c("click", window, l, !0);
  };
  return d && (d = p()) ? (w(r), m(() => {
    e -= 1, e === 0 && f("click", window, a, !0), f("click", window, l, !0), t();
  })) : r(), u(n);
}
export {
  h as default
};
